import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '@tech-services/session.service';

@Component({
  selector: 'tech-agentaccess',
  templateUrl: './agentaccess.component.html',
  styleUrls: ['./agentaccess.component.scss'],
})
export class AgentaccessComponent implements OnInit {
  private clientCode: string;
  private sessionToken: string;
  private domain: string;
  private language: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected sessionService: SessionService
  ) {}

  ngOnInit() {
    this.receiveData();
  }

  private receiveData() {
    
    localStorage.setItem('IsClient', '1');
    localStorage.setItem('isAdvisor', 'true');


    this.router.navigate(['/portfolios']);
  }
}
